export const CONTACT_CATEGORIES = [
  { name: '', value: '' },
  { name: 'Profile setup', value: 'Profile setup' },
  { name: 'Report a bug', value: 'Report a bug' },
  { name: 'Feature request', value: 'Feature request' },
  { name: 'Technical question', value: 'Technical question' },
  { name: 'Other', value: 'Other' },
];
